/* unplugin-vue-components disabled */import { render } from "./LoadingSpinnerWithText.vue?vue&type=template&id=f17631c2&scoped=true"
import script from "./LoadingSpinnerWithText.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerWithText.vue?vue&type=script&lang=js"

import "./LoadingSpinnerWithText.vue?vue&type=style&index=0&id=f17631c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f17631c2"]])

export default __exports__